// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSocialMediaLinkedIn_root__1yMeb","outer":"IconSocialMediaLinkedIn_outer__9NZfH","g":"IconSocialMediaLinkedIn_g__3B6kL","inner":"IconSocialMediaLinkedIn_inner__rhQLs"};